import React, { useEffect, useState } from 'react';
import { Bookmark, Plus, Trash2 } from 'lucide-react';

/**
 * B2 — saved filter views for the review console. Named views store the console's
 * filter state ({status, division, market, inputter}). v1 persists to localStorage
 * (per actor + surface); the shape matches the /filter-views API so a later
 * server sync is a drop-in without changing this component's contract.
 */
const storageKey = (actor, surface) => `rfm-saved-views:${surface}:${actor || 'anon'}`;

const readViews = (actor, surface) => {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(window.localStorage.getItem(storageKey(actor, surface)) || '[]');
  } catch (e) {
    return [];
  }
};

const writeViews = (actor, surface, views) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(actor, surface), JSON.stringify(views));
  } catch (e) {
    /* no-op */
  }
};

const ForecastSavedViewsMenu = ({ actor, surface = 'review_console', currentFilters, onApply }) => {
  const [views, setViews] = useState([]);
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    setViews(readViews(actor, surface));
  }, [actor, surface]);

  const persist = (next) => {
    setViews(next);
    writeViews(actor, surface, next);
  };

  const save = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    const next = [
      ...views.filter((v) => v.name !== trimmed),
      { id: `local-${Date.now()}`, name: trimmed, filters: currentFilters }
    ];
    persist(next);
    setName('');
    setNaming(false);
  };

  const remove = (id) => persist(views.filter((v) => v.id !== id));

  return (
    <div className="forecast-saved-views">
      <span className="forecast-saved-views-label"><Bookmark size={12} /> Views</span>
      {views.map((view) => (
        <span key={view.id} className="forecast-saved-view-chip">
          <button type="button" onClick={() => onApply(view.filters)}>{view.name}</button>
          <button type="button" className="remove" title="Delete view" onClick={() => remove(view.id)}>
            <Trash2 size={11} />
          </button>
        </span>
      ))}
      {naming ? (
        <span className="forecast-saved-view-namer">
          <input
            autoFocus
            value={name}
            placeholder="View name"
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setNaming(false); }}
          />
          <button type="button" className="forecast-home-action" onClick={save}>Save</button>
        </span>
      ) : (
        <button type="button" className="forecast-home-action ghost" onClick={() => setNaming(true)}>
          <Plus size={11} /> Save current
        </button>
      )}
    </div>
  );
};

export default ForecastSavedViewsMenu;
